var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasElements)?_c('div',[_vm._v("Showing entries from "+_vm._s(_vm.meta.from)+" to "+_vm._s(_vm.meta.to)+" of "+_vm._s(_vm.meta.total))]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }